//This config is added to remove the localstorage keys that we are storing to achieve url and data persistence . And is made compatible to BE conditions
export const updateAutomationRuleLocalStorageItemsList = ['automationRulePk', 'automationRuleSk'];

export const automationErroLogLocalStorageItemsList = ['automationErrorLogParentSk', 'automationErrorLogParentPk'];
